import { computed, ref } from 'vue';

import { AxiosResponse } from 'axios';
import { cloneDeep } from 'lodash';
import { defineStore } from 'pinia';

import { requestAdminHome } from '@/api/apiService';
import { IResponsePartner, IResponsePartnerEmployee, IResponsePartnerHome } from '@/types/response';

const defaultPartnerEmployee: IResponsePartnerEmployee = {
  userId: '',
  loginId: '',
  username: '',
  nickname: '',
  userType: 'GUEST',
  languageCode: 'ko',
  partnerGroups: [],
};
const defaultPartner: IResponsePartner = {
  partnerId: 0,
  partnerName: '',
  partnerCode: '',
  partnerLogoImageUrl: '',
};

export const useAdminStore = defineStore('admin', () => {
  /* states */
  const partnerEmployeeInfo = ref<IResponsePartnerEmployee>(cloneDeep(defaultPartnerEmployee));
  const partnerInfo = ref<IResponsePartner>(cloneDeep(defaultPartner));

  /* getters */
  const getPartnerEmployeeInfo = computed<IResponsePartnerEmployee>(() => {
    return partnerEmployeeInfo.value;
  });
  const getPartnerInfo = computed<IResponsePartner>(() => {
    return partnerInfo.value;
  });
  const getGroupName = computed<string>(() => {
    const { partnerGroups = [] } = partnerEmployeeInfo.value;
    const [{ groupName = '' } = { groupName: '' }] = partnerGroups;
    return groupName;
  });

  const isHost = computed(() => {
    return getPartnerEmployeeInfo.value.userType === 'HOST';
  });

  /* actions */
  const fetchPartnerHome = async () => {
    try {
      const res: AxiosResponse<IResponsePartnerHome> = await requestAdminHome();
      const {
        data: { partnerEmployeeResponse, partnerResponse },
      } = res;
      [partnerEmployeeInfo.value, partnerInfo.value] = [partnerEmployeeResponse, partnerResponse];
    } catch (error) {
      console.debug('어드민 정보 조회 실패', error);
      [partnerEmployeeInfo.value, partnerInfo.value] = [defaultPartnerEmployee, defaultPartner];
    }
  };
  const updateUserName = (name: string) => {
    Object.assign(partnerEmployeeInfo.value, {
      ...partnerEmployeeInfo.value,
      name,
    });
  };

  return {
    /* getters */
    getPartnerEmployeeInfo,
    getPartnerInfo,
    getGroupName,
    isHost,
    /* actions */
    fetchPartnerHome,
    updateUserName,
  };
});
